<div class="cx-modal-container">
    <div class="cx-modal-content">
      <div class="cx-dialog-header modal-header">
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="closeModal('close')"
        >
          <i class="material-icons">close</i>
        </button>
      </div>
      <div class="cx-dialog-body modal-body">
        <div class="row">
          <div class="error-ordercheckout">
            <p class="order-paragraph">
              <i class="material-icons custom-info-icon">report</i>
              <span class="header-msg">Alert</span>
            </p>
            <span class="alert-text-msg"
              >Until further notice, Baker Hughes is no longer accepting orders
              which ship to or are sold to Russian legal entities, or have Russian
              end users. Please contact your CSR for any additional
              clarifications.</span
            >
          </div>
        </div>
      </div>
      <div class="cx-dialog-footer modal-footer">
        <div class="row">
          <div class="col-sm-12 col-md-12 action-container">
            <button class="vs-text-btn action-btn" (click)="closeModal('close')">
              <span>Cancel</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  